export const UPDATE_USER = "@iweb/UPDATE_USER"
